import { QueryConfig } from "store/utils/query-config";

export const articleDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"],
  },
};
